import {Provider as MosaicProvider, useIconStore} from '@stoplight/mosaic';
import React, {useEffect, useState} from 'react';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
//import { BrowserRouter as Router} from 'react-router-dom';
import {Api} from './components/Api';
import {Navigation} from './components/Navigation';
import {NotFound} from './components/NotFound';
import constants from './constants';
import {GlobalContext} from './context';

export default () => {
  const sp = new URLSearchParams(window.location.search);
  const setDefaultStyle = useIconStore(state => state.setDefaultStyle);

  const [globalState, setGlobalState] = useState<GlobalContext>({
    apiDescriptionUrl: sp.get('spec') || "",
    setDescriptionUrl: _value => {
      const value = _value.trim() || constants.defaultSpecUrl;
      let spec = constants.specs.find(o => o.value === value);
      if (!spec) {
        return;
      }
        
      let nextUrl = '/';
      if (value) {
        nextUrl = `?spec=${spec.value}`;
      }

      window.history.pushState(undefined, '', nextUrl);

      setTimeout(() => {
        setGlobalState({
          ...globalState,
          apiDescriptionUrl: spec.value,
        });
      }, 0);
    },
  });

  useEffect(() => {
    setDefaultStyle('fal');
    
    if (!globalState.apiDescriptionUrl) {
      globalState.setDescriptionUrl(constants.defaultSpecUrl);
    }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <MosaicProvider>
      <Router>
        <GlobalContext.Provider value={globalState}>
          <div className="app-container">
            <header style={{ position: "fixed", width: "100%", zIndex: "1" }}>
              <Navigation />
            </header>
            <main className="main-content" style={{marginTop : "58px"}}>
              <Switch>
                <Route path="/" component={Api} />
                <Route component={NotFound} />
              </Switch>
            </main>
          </div>
        </GlobalContext.Provider>
      </Router>
    </MosaicProvider>
  );
}


